import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavTemplateFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#413735"
      d="M8.5 12v8H2v-8h6.5ZM22 12v8H10.5v-8H22Zm0-8v6H2V4h20Z"
    />
  </svg>
);
export default SvgNavTemplateFill;
